import { MenuItem, Select, Stack, TextField } from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { createInventory } from "../../api"
import { useSnackbar } from "notistack"

const statuses = ["ACTIVE", "INACTIVE"]
const types = ["CONSUMABLE", "SPARE_PART", "COMPONENT", "TOOL_AND_KIT"]

const AddInventory = ({ data, ...props }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const [inventoryDetails, setInventoryDetails] = useState({
    name: "",
    type: "CONSUMABLE",
    status: "ACTIVE",
    model: "",
    serialNumber: "",
  })

  const handleChange = (event) => {
    const { name, value } = event.target
    setInventoryDetails({
      ...inventoryDetails,
      [name]: value,
    })
  }

  const handleSubmit = () => {
    setLoading(true)
    createInventory(inventoryDetails)
      .then(() => {
        enqueueSnackbar("Inventory added.", { variant: "success" })
        props.refresh()
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      {...props}
      title="Add Inventory"
      actionText={"Add"}
      action={handleSubmit}
      loading={loading}
    >
      <Stack>
        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Inventory Name">
            <TextField
              name="name"
              value={inventoryDetails.name}
              onChange={handleChange}
            />
          </FormItem>
          <FormItem label="Type">
            <Select
              name="type"
              value={inventoryDetails.type}
              onChange={handleChange}
            >
              {types.map((type) => (
                <MenuItem value={type}>{type}</MenuItem>
              ))}
            </Select>
          </FormItem>
          <FormItem label="Status">
            <Select
              name="status"
              value={inventoryDetails.status}
              onChange={handleChange}
            >
              {statuses.map((s) => (
                <MenuItem value={s}>{s}</MenuItem>
              ))}
            </Select>
          </FormItem>
        </Stack>
        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Model">
            <TextField
              name="model"
              value={inventoryDetails.model}
              onChange={handleChange}
            />
          </FormItem>
          <FormItem label="Serial No.">
            <TextField
              name="serialNumber"
              value={inventoryDetails.serialNumber}
              onChange={handleChange}
            />
          </FormItem>
        </Stack>
      </Stack>
    </Modal>
  )
}

export default AddInventory
